import type { UseFetchOptions } from 'nuxt/app'
import type { StrapiApiDefaultResponse } from '~/composables/types/strapi-api'
import type { StrapiMagazineArticle } from '~/composables/types/strapi/strapi-magazine'
import { dynamicContentTransformer } from '~/utils/dynamicContentTransformer'
import { getStrapiArticlesUrl as getOptimizedStrapiArticlesUrl } from '~/utils/strapiURLhelpers'

export function useStrapiArticles({
  slug,
  query,
  options = {},
  locale,
}: {
  slug?: string
  query?: Record<string, string>
  options?: UseFetchOptions<
    StrapiApiDefaultResponse<StrapiMagazineArticle[]>,
    StrapiMagazineArticle[]
  >
  locale?: string
  preview?: boolean
} = {}) {
  const localeDefault = useI18n().locale

  const articlesUrl = getOptimizedStrapiArticlesUrl(
    slug,
    locale || localeDefault.value,
    query
  )

  const staticMetrics = useStaticMetrics()
  const localeToUse = locale || localeDefault.value

  const baseTransform = (
    data: StrapiApiDefaultResponse<StrapiMagazineArticle[]>
  ): StrapiMagazineArticle[] => {
    return data.data.map((item) =>
      dynamicContentTransformer(item, staticMetrics, localeToUse)
    )
  }

  return useStrapi<StrapiMagazineArticle>({
    urlSuffix: articlesUrl,
    options: { ...options, transform: baseTransform },
  })
}
